import {User} from "../components/User";
import {FormComponent} from "../components/FormComponent";
import {FormGroup} from "../components/FormComponent/FormGroup";
import React from "react";

export class LoginPage extends FormComponent {

    protected getRequestUrl(): RequestInfo | URL {
        return '/login';
    }

    protected onSuccess(data: { user: User, token: string } | any) {
        this.user.set(data.user, data.token);
        window.location.reload();
    }

    protected onError(error: any) {
        (document.querySelector('form .alert') as HTMLElement).innerHTML = this.dictionary.get[error.message];
        (document.querySelector('form .alert') as HTMLElement).classList.remove('hide');
    }

    render() {
        return (
            <div className="login-page">
                <div>
                    <div className="col-11 col-sm-9 col-md-7 col-lg-5 col-xl-4 col-xxl-3">
                        <form onSubmit={this.handleSubmit}>
                            <h3>{this.dictionary.get['login']}</h3>

                            <FormGroup.Input {...{
                                id: 'email',
                                name: 'username',
                                type: 'email',
                                help: 'email-anyone',
                                autoComplete: 'username',
                                placeholder: this.dictionary.get['email']
                            }}/>

                            <FormGroup.Input {...{
                                id: 'password',
                                type: 'password',
                                autoComplete: 'current-password',
                                placeholder: this.dictionary.get['password']
                            }}/>

                            <div className="form-group">
                                <button type="submit"
                                        className="btn btn-primary">{this.dictionary.get['login']}</button>
                                
                                <a style={{
                                    textDecoration: 'none', float: 'right',
                                    top: '9px',
                                    position: 'relative',
                                    fontSize: '14px'
                                }}
                                   href={'/forgot-password'}>{this.dictionary.get['forgot-password']}</a>
                            </div>

                            <div className="alert alert-danger hide" role="alert">
                                {this.dictionary.get['unknown-error']}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    };
}
